(function () {
    window.addEventListener('load', function () {
        var newRelicInterval = setInterval(function () {
            if (!window.newrelic) {
                return;
            }
            window.$ &&
                window.$.migrateWarnings &&
                window.$.migrateWarnings.forEach(function (message) {
                    window.newrelic.noticeError(new Error(message));
                });
            window.newrelic.setErrorHandler(function (error) {
                return !!(
                    error.message && error.message.match(/Script error(\.)?/i)
                );
            });
            window.newrelic.setCustomAttribute('SPA', 0);

            if (window.ApplicationProperties) {
                window.newrelic.setCustomAttribute(
                    'isAppMode',
                    +ApplicationProperties.get('isAppMode')
                );
                window.newrelic.setCustomAttribute(
                    'isBotCall',
                    +ApplicationProperties.get('isBot')
                );
                window.newrelic.setCustomAttribute(
                    'isInternalCall',
                    +!ApplicationProperties.get('external')
                );
                window.newrelic.setCustomAttribute(
                    'isInfolineCall',
                    +ApplicationProperties.get('isInfolineIp')
                );
                window.newrelic.setCustomAttribute(
                    'isAffiliateCall',
                    +(ApplicationProperties.get('affiliate') !== 'bm')
                );
                window.newrelic.setCustomAttribute(
                    'isLoggedIn',
                    +ApplicationProperties.get('isLoggedIn')
                );
                window.newrelic.setCustomAttribute(
                    'userLanguage',
                    navigator.language || navigator.userLanguage
                );
            }
            clearInterval(newRelicInterval);
        }, 500);
    });
})();
